const cookieNotice = {
  fr:
    'Ce site enregistre des cookies sur votre ordinateur. Ils servent à comprendre comment vous utilisez le site et à vous reconnaître. Nous les utilisons pour améliorer et personnaliser votre navigation, ainsi que pour les analyses et indicateurs sur ce site et d’autres médias. Pour en savoir plus sur les cookies que nous utilisons, consultez notre',
  de:
    'Diese Website speichert Cookies auf Ihrem Computer. Diese Cookies erfassen, wie Sie mit unserer Website interagieren, und ermöglichen es uns, Sie wiederzuerkennen. Wir nutzen diese Informationen, um Ihr Surferlebnis zu verbessern und zu personalisieren sowie für Analysen und Kennzahlen zu unseren Besuchern auf dieser Website und in anderen Medien. Weitere Informationen zu den von uns verwendeten Cookies finden Sie in unserer',
  es:
    'Este sitio web almacena cookies en tu ordenador. Estas cookies se usan para recopilar información sobre cómo interactúas con nuestro sitio y para recordarte. Usamos esta información para mejorar y personalizar tu experiencia de navegación y para analítica y métricas sobre nuestros visitantes en este sitio y en otros medios. Para saber más sobre las cookies que usamos, consulta nuestra',
  pt:
    'Este site armazena cookies no seu computador. Esses cookies coletam informações sobre como você interage com o site e nos permitem reconhecê-lo. Usamos essas informações para melhorar e personalizar sua navegação e para análises e métricas sobre nossos visitantes neste site e em outros meios. Para saber mais sobre os cookies que usamos, consulte nossa',
  zh_CN:
    '本网站会在您的计算机上存储 Cookie。这些 Cookie 用于了解您如何与网站互动并记住您。我们使用这些信息来改进和个性化浏览体验，以及分析本网站和其他媒体上的访问者。要了解我们使用的 Cookie，请参阅我们的',
  zh_TW:
    '本網站會在您的電腦上儲存 Cookie。這些 Cookie 用來了解您如何與網站互動並記住您。我們使用這些資訊來改善並個人化瀏覽體驗，以及分析本網站與其他媒體上的訪客。若要進一步了解我們使用的 Cookie，請參閱我們的',
  it:
    'Questo sito memorizza cookie sul tuo computer. I cookie raccolgono informazioni su come interagisci con il sito e ci permettono di riconoscerti. Usiamo queste informazioni per migliorare e personalizzare la navigazione e per analisi e metriche sui visitatori di questo sito e di altri media. Per saperne di più sui cookie che utilizziamo, consulta la nostra',
  ko:
    '이 웹사이트는 컴퓨터에 쿠키를 저장합니다. 쿠키는 사이트 이용 방식을 파악하고 사용자를 기억하는 데 사용됩니다. 이 정보는 탐색 경험을 개선·맞춤화하고 이 사이트와 다른 매체의 방문자를 분석하는 데 쓰입니다. 사용하는 쿠키에 대해 자세히 알아보려면 다음을 확인하세요.',
  nl:
    'Deze website slaat cookies op uw computer op. Deze cookies verzamelen informatie over hoe u onze website gebruikt en stellen ons in staat u te herkennen. We gebruiken deze informatie om uw browse-ervaring te verbeteren en te personaliseren en voor analyses en statistieken over bezoekers op deze website en andere media. Meer informatie over de cookies die we gebruiken vindt u in ons',
  fi:
    'Tämä sivusto tallentaa evästeitä tietokoneellesi. Evästeillä kerätään tietoa sivuston käytöstä ja sinut voidaan tunnistaa. Käytämme tietoja selauskokemuksen parantamiseen ja personointiin sekä analytiikkaan tällä sivustolla ja muissa medioissa. Lisätietoja käyttämistämme evästeistä on',
  ru:
    'Этот сайт сохраняет файлы cookie на вашем компьютере. Они помогают понять, как вы взаимодействуете с сайтом, и запомнить вас. Мы используем эти данные, чтобы улучшать и персонализировать просмотр, а также для аналитики посетителей на этом сайте и в других медиа. Подробнее о cookie — в нашей',
  sv:
    'Den här webbplatsen lagrar cookies på din dator. Cookies används för att samla in information om hur du använder webbplatsen och för att komma ihåg dig. Vi använder informationen för att förbättra och anpassa din upplevelse samt för analys och mätvärden om besökare på den här webbplatsen och i andra medier. Läs mer om cookies vi använder i vår',
  ja:
    'このウェブサイトはお使いのコンピュータに Cookie を保存します。Cookie はサイトの利用状況を把握し、お客様を記憶するために使用されます。閲覧体験の改善・パーソナライズ、および本サイトや他メディアの訪問者分析に利用します。使用する Cookie の詳細は、次をご覧ください。',
  tr:
    'Bu web sitesi bilgisayarınıza çerezler kaydeder. Çerezler sitede nasıl gezindiğinizi anlamamıza ve sizi hatırlamamıza yarar. Bu bilgileri gezinme deneyimini iyileştirmek ve kişiselleştirmek ile bu sitedeki ve diğer mecralardaki ziyaretçiler için analiz amacıyla kullanırız. Kullandığımız çerezler hakkında daha fazla bilgi için bakın:',
  cs:
    'Tento web ukládá soubory cookie do vašeho počítače. Cookie slouží ke zjištění, jak web používáte, a k vašemu zapamatování. Tyto informace používáme ke zlepšení a přizpůsobení prohlížení a k analytice návštěvníků na tomto webu i v dalších médiích. Více o používaných cookie najdete v našich',
  el:
    'Αυτός ο ιστότοπος αποθηκεύει cookies στον υπολογιστή σας. Τα cookies συλλέγουν πληροφορίες για το πώς αλληλεπιδράτε με τον ιστότοπο και μας επιτρέπουν να σας θυμόμαστε. Χρησιμοποιούμε αυτές τις πληροφορίες για να βελτιώσουμε και να προσαρμόσουμε την περιήγηση, καθώς και για αναλύσεις επισκεπτών σε αυτόν τον ιστότοπο και άλλα μέσα. Για περισσότερα σχετικά με τα cookies που χρησιμοποιούμε, δείτε την',
  hr:
    'Ova web-stranica pohranjuje kolačiće na vašem računalu. Kolačići prikupljaju podatke o tome kako koristite stranicu i omogućuju nam da vas prepoznamo. Te podatke koristimo za poboljšanje i prilagodbu pregledavanja te za analitiku posjetitelja na ovoj stranici i drugim medijima. Više o kolačićima koje koristimo potražite u našem',
}

const sharedDashboard = {
  'dashboard.successHub': 'Success Hub',
  'dashboard.parqs': 'PARQs',
  'dashboard.parq': 'ParQ',
  'nav.qc': 'QC',
  'nav.snapFailures': 'Snap Failures',
}

export default {
  fr: {
    ...sharedDashboard,
    'cookie.notice': cookieNotice.fr,
    'dashboard.usageDashboard': "Tableau de bord d'utilisation",
    'dashboard.summary': 'Résumé',
    'dashboard.users': 'Utilisateurs',
    'dashboard.coaches': 'Coachs',
    'dashboard.scans': 'Scans',
    'dashboard.wins': 'Gains',
    'dashboard.win': 'Gain',
    'dashboard.winRate': 'Taux de gains',
    'dashboard.coachActivity': 'Activité des coachs',
    'dashboard.coachActivityMonthly': 'Activité des coachs (mensuelle)',
    'dashboard.newUsers': 'Nouveaux utilisateurs',
    'dashboard.newUsersMonthly': 'Nouveaux utilisateurs (mensuel)',
    'dashboard.activeUsers': 'Utilisateurs actifs',
    'dashboard.activeUsersMonthly': 'Utilisateurs actifs (mensuel)',
    'dashboard.newScans': 'Nouveaux scans',
    'dashboard.newScansMonthly': 'Nouveaux scans (mensuel)',
    'dashboard.maybe': 'Peut-être',
    'dashboard.no': 'Non',
    'dashboard.month': 'Mois',
    'dashboard.coachActivityLeaders': "Leaders d'activité des coachs",
    'dashboard.coachLeadersCurrentMonth': 'Leaders coachs (mois en cours)',
    'dashboard.coachLeadersAllTime': 'Leaders coachs (total)',
    'dashboard.whatIsThis': "Qu'est-ce que c'est ?",
    'dashboard.coachLeadersExplanation':
      'Les coachs sont classés selon leurs ParQs complétés et leurs gains (clients potentiels marqués comme intéressés).',
    'dashboard.notAvailable': 'N/D',
  },
  de: {
    'nav.qc': 'QC',
    'cookie.notice': cookieNotice.de,
  },
  es: {
    ...sharedDashboard,
    'cookie.notice': cookieNotice.es,
    'dashboard.usageDashboard': 'Panel de uso',
    'dashboard.summary': 'Resumen',
    'dashboard.users': 'Usuarios',
    'dashboard.coaches': 'Entrenadores',
    'dashboard.scans': 'Escaneos',
    'dashboard.wins': 'Éxitos',
    'dashboard.win': 'Éxito',
    'dashboard.winRate': 'Tasa de éxitos',
    'dashboard.coachActivity': 'Actividad de entrenadores',
    'dashboard.coachActivityMonthly': 'Actividad de entrenadores (mensual)',
    'dashboard.newUsers': 'Nuevos usuarios',
    'dashboard.newUsersMonthly': 'Nuevos usuarios (mensual)',
    'dashboard.activeUsers': 'Usuarios activos',
    'dashboard.activeUsersMonthly': 'Usuarios activos (mensual)',
    'dashboard.newScans': 'Nuevos escaneos',
    'dashboard.newScansMonthly': 'Nuevos escaneos (mensual)',
    'dashboard.maybe': 'Quizá',
    'dashboard.no': 'No',
    'dashboard.month': 'Mes',
    'dashboard.coachActivityLeaders': 'Líderes de actividad de entrenadores',
    'dashboard.coachLeadersCurrentMonth':
      'Líderes de entrenadores (mes actual)',
    'dashboard.coachLeadersAllTime': 'Líderes de entrenadores (histórico)',
    'dashboard.whatIsThis': '¿Qué es esto?',
    'dashboard.coachLeadersExplanation':
      'Los entrenadores se clasifican según los ParQ completados y los éxitos (clientes potenciales marcados como interesados).',
    'dashboard.notAvailable': 'N/D',
  },
  pt: {
    ...sharedDashboard,
    'cookie.notice': cookieNotice.pt,
    'dashboard.usageDashboard': 'Painel de uso',
    'dashboard.summary': 'Resumo',
    'dashboard.users': 'Usuários',
    'dashboard.coaches': 'Coaches',
    'dashboard.scans': 'Scans',
    'dashboard.wins': 'Vitórias',
    'dashboard.win': 'Vitória',
    'dashboard.winRate': 'Taxa de vitórias',
    'dashboard.coachActivity': 'Atividade dos coaches',
    'dashboard.coachActivityMonthly': 'Atividade dos coaches (mensal)',
    'dashboard.newUsers': 'Novos usuários',
    'dashboard.newUsersMonthly': 'Novos usuários (mensal)',
    'dashboard.activeUsers': 'Usuários ativos',
    'dashboard.activeUsersMonthly': 'Usuários ativos (mensal)',
    'dashboard.newScans': 'Novos scans',
    'dashboard.newScansMonthly': 'Novos scans (mensal)',
    'dashboard.maybe': 'Talvez',
    'dashboard.no': 'Não',
    'dashboard.month': 'Mês',
    'dashboard.coachActivityLeaders': 'Líderes de atividade dos coaches',
    'dashboard.coachLeadersCurrentMonth': 'Líderes de coaches (mês atual)',
    'dashboard.coachLeadersAllTime': 'Líderes de coaches (histórico)',
    'dashboard.whatIsThis': 'O que é isto?',
    'dashboard.coachLeadersExplanation':
      'Os coaches são classificados com base nos ParQs concluídos e nas vitórias (clientes potenciais marcados como interessados).',
    'dashboard.notAvailable': 'N/D',
  },
  it: {
    'nav.admin': 'Admin',
    'nav.fit3dAdmin': 'Admin Fit3D',
    'nav.market': 'Mercato',
    'nav.marketplace': 'Marketplace',
    'nav.survey': 'Sondaggio',
    'nav.records': 'Schede',
    'nav.qc': 'QC',
    'nav.facilities': 'Strutture',
    'nav.scanners': 'Scanner',
    'nav.coaches': 'Allenatori',
    'nav.users': 'Utenti',
    'nav.version': 'Versione',
    'nav.overlay': 'Sovrapposizione',
    'cookie.notice': cookieNotice.it,
  },
  zh_CN: {
    ...sharedDashboard,
    'nav.admin': '管理',
    'nav.fit3dAdmin': 'Fit3D 管理',
    'nav.market': '市场',
    'nav.marketplace': '市场',
    'nav.survey': '问卷',
    'nav.clientScans': '客户扫描',
    'nav.demoReport': '演示报告',
    'nav.demoComparison': '演示对比',
    'nav.manageCoaches': '管理教练',
    'nav.printable': '可打印',
    'nav.myCoaches': '我的教练',
    'nav.records': '记录',
    'nav.facilities': '场馆',
    'nav.scanners': '扫描仪',
    'nav.coaches': '教练',
    'nav.users': '用户',
    'nav.version': '版本',
    'nav.client': '客户',
    'nav.report': '报告',
    'nav.overlay': '叠加',
    'nav.downloadMeasurements': '下载测量数据',
    'cookie.notice': cookieNotice.zh_CN,
    'dashboard.usageDashboard': '使用情况仪表板',
    'dashboard.summary': '摘要',
    'dashboard.users': '用户',
    'dashboard.coaches': '教练',
    'dashboard.scans': '扫描',
    'dashboard.wins': '成功',
    'dashboard.win': '成功',
    'dashboard.winRate': '成功率',
    'dashboard.coachActivity': '教练活动',
    'dashboard.coachActivityMonthly': '教练活动（月度）',
    'dashboard.newUsers': '新用户',
    'dashboard.newUsersMonthly': '新用户（月度）',
    'dashboard.activeUsers': '活跃用户',
    'dashboard.activeUsersMonthly': '活跃用户（月度）',
    'dashboard.newScans': '新扫描',
    'dashboard.newScansMonthly': '新扫描（月度）',
    'dashboard.maybe': '可能',
    'dashboard.no': '否',
    'dashboard.month': '月份',
    'dashboard.coachActivityLeaders': '教练活动排行',
    'dashboard.coachLeadersCurrentMonth': '教练排行（本月）',
    'dashboard.coachLeadersAllTime': '教练排行（全部）',
    'dashboard.whatIsThis': '这是什么？',
    'dashboard.coachLeadersExplanation':
      '教练根据已完成的 ParQ 和成功数（标记为有意向的潜在客户）进行排名。',
    'dashboard.notAvailable': '暂无',
  },
  zh_TW: {
    ...sharedDashboard,
    'nav.admin': '管理',
    'nav.fit3dAdmin': 'Fit3D 管理',
    'nav.market': '市場',
    'nav.marketplace': '市集',
    'nav.survey': '問卷',
    'nav.clientScans': '客戶掃描',
    'nav.demoReport': '示範報告',
    'nav.demoComparison': '示範比較',
    'nav.manageCoaches': '管理教練',
    'nav.printable': '可列印',
    'nav.myCoaches': '我的教練',
    'nav.records': '紀錄',
    'nav.facilities': '場館',
    'nav.scanners': '掃描器',
    'nav.coaches': '教練',
    'nav.users': '使用者',
    'nav.version': '版本',
    'nav.client': '客戶',
    'nav.report': '報告',
    'nav.overlay': '疊加',
    'nav.downloadMeasurements': '下載測量資料',
    'cookie.notice': cookieNotice.zh_TW,
    'dashboard.usageDashboard': '使用情況儀表板',
    'dashboard.summary': '摘要',
    'dashboard.users': '使用者',
    'dashboard.coaches': '教練',
    'dashboard.scans': '掃描',
    'dashboard.wins': '成功',
    'dashboard.win': '成功',
    'dashboard.winRate': '成功率',
    'dashboard.coachActivity': '教練活動',
    'dashboard.coachActivityMonthly': '教練活動（每月）',
    'dashboard.newUsers': '新使用者',
    'dashboard.newUsersMonthly': '新使用者（每月）',
    'dashboard.activeUsers': '活躍使用者',
    'dashboard.activeUsersMonthly': '活躍使用者（每月）',
    'dashboard.newScans': '新掃描',
    'dashboard.newScansMonthly': '新掃描（每月）',
    'dashboard.maybe': '或許',
    'dashboard.no': '否',
    'dashboard.month': '月份',
    'dashboard.coachActivityLeaders': '教練活動排行',
    'dashboard.coachLeadersCurrentMonth': '教練排行（本月）',
    'dashboard.coachLeadersAllTime': '教練排行（全部）',
    'dashboard.whatIsThis': '這是什麼？',
    'dashboard.coachLeadersExplanation':
      '教練依完成的 ParQ 與成功數（標記為有興趣的潛在客戶）排名。',
    'dashboard.notAvailable': '暫無',
  },
  ko: {
    ...sharedDashboard,
    'nav.admin': '관리',
    'nav.fit3dAdmin': 'Fit3D 관리',
    'nav.market': '마켓',
    'nav.marketplace': '마켓플레이스',
    'nav.survey': '설문',
    'nav.clientScans': '고객 스캔',
    'nav.demoReport': '데모 리포트',
    'nav.demoComparison': '데모 비교',
    'nav.manageCoaches': '코치 관리',
    'nav.printable': '인쇄용',
    'nav.myCoaches': '내 코치',
    'nav.records': '기록',
    'nav.facilities': '시설',
    'nav.scanners': '스캐너',
    'nav.coaches': '코치',
    'nav.users': '사용자',
    'nav.version': '버전',
    'nav.client': '고객',
    'nav.report': '리포트',
    'nav.overlay': '오버레이',
    'nav.downloadMeasurements': '측정값 다운로드',
    'cookie.notice': cookieNotice.ko,
    'dashboard.usageDashboard': '사용 현황 대시보드',
    'dashboard.summary': '요약',
    'dashboard.users': '사용자',
    'dashboard.coaches': '코치',
    'dashboard.scans': '스캔',
    'dashboard.wins': '성공',
    'dashboard.win': '성공',
    'dashboard.winRate': '성공률',
    'dashboard.coachActivity': '코치 활동',
    'dashboard.coachActivityMonthly': '코치 활동 (월간)',
    'dashboard.newUsers': '신규 사용자',
    'dashboard.newUsersMonthly': '신규 사용자 (월간)',
    'dashboard.activeUsers': '활성 사용자',
    'dashboard.activeUsersMonthly': '활성 사용자 (월간)',
    'dashboard.newScans': '신규 스캔',
    'dashboard.newScansMonthly': '신규 스캔 (월간)',
    'dashboard.maybe': '아마도',
    'dashboard.no': '아니요',
    'dashboard.month': '월',
    'dashboard.coachActivityLeaders': '코치 활동 리더',
    'dashboard.coachLeadersCurrentMonth': '코치 리더 (이번 달)',
    'dashboard.coachLeadersAllTime': '코치 리더 (전체)',
    'dashboard.whatIsThis': '이것은 무엇인가요?',
    'dashboard.coachLeadersExplanation':
      '코치는 완료한 ParQ와 성공(관심 있음으로 표시한 잠재 고객)을 기준으로 순위가 매겨집니다.',
    'dashboard.notAvailable': '없음',
  },
  nl: {
    ...sharedDashboard,
    'nav.admin': 'Beheer',
    'nav.fit3dAdmin': 'Fit3D-beheer',
    'nav.market': 'Markt',
    'nav.marketplace': 'Marktplaats',
    'nav.survey': 'Enquête',
    'nav.clientScans': 'Klantscans',
    'nav.demoReport': 'Demorapport',
    'nav.demoComparison': 'Demovergelijking',
    'nav.manageCoaches': 'Coaches beheren',
    'nav.printable': 'Afdrukbaar',
    'nav.myCoaches': 'Mijn coaches',
    'nav.records': 'Dossiers',
    'nav.facilities': 'Locaties',
    'nav.scanners': 'Scanners',
    'nav.coaches': 'Coaches',
    'nav.users': 'Gebruikers',
    'nav.version': 'Versie',
    'nav.client': 'Klant',
    'nav.report': 'Rapport',
    'nav.overlay': 'Overlay',
    'nav.downloadMeasurements': 'Metingen downloaden',
    'cookie.notice': cookieNotice.nl,
    'dashboard.usageDashboard': 'Gebruiksdashboard',
    'dashboard.summary': 'Overzicht',
    'dashboard.users': 'Gebruikers',
    'dashboard.coaches': 'Coaches',
    'dashboard.scans': 'Scans',
    'dashboard.wins': 'Wins',
    'dashboard.win': 'Win',
    'dashboard.winRate': 'Winpercentage',
    'dashboard.coachActivity': 'Coachactiviteit',
    'dashboard.coachActivityMonthly': 'Coachactiviteit (maandelijks)',
    'dashboard.newUsers': 'Nieuwe gebruikers',
    'dashboard.newUsersMonthly': 'Nieuwe gebruikers (maandelijks)',
    'dashboard.activeUsers': 'Actieve gebruikers',
    'dashboard.activeUsersMonthly': 'Actieve gebruikers (maandelijks)',
    'dashboard.newScans': 'Nieuwe scans',
    'dashboard.newScansMonthly': 'Nieuwe scans (maandelijks)',
    'dashboard.maybe': 'Misschien',
    'dashboard.no': 'Nee',
    'dashboard.month': 'Maand',
    'dashboard.coachActivityLeaders': 'Leiders coachactiviteit',
    'dashboard.coachLeadersCurrentMonth': 'Coachleiders (huidige maand)',
    'dashboard.coachLeadersAllTime': 'Coachleiders (alles)',
    'dashboard.whatIsThis': 'Wat is dit?',
    'dashboard.coachLeadersExplanation':
      'Coaches worden gerangschikt op voltooide ParQs en wins (potentiële klanten die ze als geïnteresseerd hebben gemarkeerd).',
    'dashboard.notAvailable': 'n.v.t.',
  },
  fi: {
    ...sharedDashboard,
    'nav.admin': 'Hallinta',
    'nav.fit3dAdmin': 'Fit3D-hallinta',
    'nav.market': 'Markkinat',
    'nav.marketplace': 'Markkinapaikka',
    'nav.survey': 'Kysely',
    'nav.clientScans': 'Asiakkaan skannaukset',
    'nav.demoReport': 'Demoraportti',
    'nav.demoComparison': 'Demovertailu',
    'nav.manageCoaches': 'Hallitse valmentajia',
    'nav.printable': 'Tulostettava',
    'nav.myCoaches': 'Valmentajani',
    'nav.records': 'Tiedot',
    'nav.facilities': 'Toimipisteet',
    'nav.scanners': 'Skannerit',
    'nav.coaches': 'Valmentajat',
    'nav.users': 'Käyttäjät',
    'nav.version': 'Versio',
    'nav.client': 'Asiakas',
    'nav.report': 'Raportti',
    'nav.overlay': 'Päällekkäisnäkymä',
    'nav.downloadMeasurements': 'Lataa mitat',
    'cookie.notice': cookieNotice.fi,
    'dashboard.usageDashboard': 'Käytön hallintapaneeli',
    'dashboard.summary': 'Yhteenveto',
    'dashboard.users': 'Käyttäjät',
    'dashboard.coaches': 'Valmentajat',
    'dashboard.scans': 'Skannaukset',
    'dashboard.wins': 'Voitot',
    'dashboard.win': 'Voitto',
    'dashboard.winRate': 'Voittoprosentti',
    'dashboard.coachActivity': 'Valmentajien aktiivisuus',
    'dashboard.coachActivityMonthly':
      'Valmentajien aktiivisuus (kuukausittain)',
    'dashboard.newUsers': 'Uudet käyttäjät',
    'dashboard.newUsersMonthly': 'Uudet käyttäjät (kuukausittain)',
    'dashboard.activeUsers': 'Aktiiviset käyttäjät',
    'dashboard.activeUsersMonthly': 'Aktiiviset käyttäjät (kuukausittain)',
    'dashboard.newScans': 'Uudet skannaukset',
    'dashboard.newScansMonthly': 'Uudet skannaukset (kuukausittain)',
    'dashboard.maybe': 'Ehkä',
    'dashboard.no': 'Ei',
    'dashboard.month': 'Kuukausi',
    'dashboard.coachActivityLeaders': 'Valmentaja-aktiivisuuden kärki',
    'dashboard.coachLeadersCurrentMonth': 'Valmentajakärki (kuluva kuukausi)',
    'dashboard.coachLeadersAllTime': 'Valmentajakärki (kaikki)',
    'dashboard.whatIsThis': 'Mikä tämä on?',
    'dashboard.coachLeadersExplanation':
      'Valmentajat sijoitetaan suoritettujen ParQ-kyselyjen ja voittojen (kiinnostuneiksi merkittyjen potentiaalisten asiakkaiden) perusteella.',
    'dashboard.notAvailable': 'Ei saatavilla',
  },
  ru: {
    ...sharedDashboard,
    'nav.admin': 'Админ',
    'nav.fit3dAdmin': 'Админ Fit3D',
    'nav.market': 'Маркет',
    'nav.marketplace': 'Маркетплейс',
    'nav.survey': 'Опрос',
    'nav.clientScans': 'Сканы клиентов',
    'nav.demoReport': 'Демо-отчёт',
    'nav.demoComparison': 'Демо-сравнение',
    'nav.manageCoaches': 'Управление тренерами',
    'nav.printable': 'Для печати',
    'nav.myCoaches': 'Мои тренеры',
    'nav.records': 'Записи',
    'nav.facilities': 'Объекты',
    'nav.scanners': 'Сканеры',
    'nav.coaches': 'Тренеры',
    'nav.users': 'Пользователи',
    'nav.version': 'Версия',
    'nav.client': 'Клиент',
    'nav.report': 'Отчёт',
    'nav.overlay': 'Наложение',
    'nav.downloadMeasurements': 'Скачать измерения',
    'cookie.notice': cookieNotice.ru,
    'dashboard.usageDashboard': 'Панель использования',
    'dashboard.summary': 'Сводка',
    'dashboard.users': 'Пользователи',
    'dashboard.coaches': 'Тренеры',
    'dashboard.scans': 'Сканы',
    'dashboard.wins': 'Успехи',
    'dashboard.win': 'Успех',
    'dashboard.winRate': 'Доля успехов',
    'dashboard.coachActivity': 'Активность тренеров',
    'dashboard.coachActivityMonthly': 'Активность тренеров (за месяц)',
    'dashboard.newUsers': 'Новые пользователи',
    'dashboard.newUsersMonthly': 'Новые пользователи (за месяц)',
    'dashboard.activeUsers': 'Активные пользователи',
    'dashboard.activeUsersMonthly': 'Активные пользователи (за месяц)',
    'dashboard.newScans': 'Новые сканы',
    'dashboard.newScansMonthly': 'Новые сканы (за месяц)',
    'dashboard.maybe': 'Возможно',
    'dashboard.no': 'Нет',
    'dashboard.month': 'Месяц',
    'dashboard.coachActivityLeaders': 'Лидеры по активности тренеров',
    'dashboard.coachLeadersCurrentMonth':
      'Лидеры среди тренеров (текущий месяц)',
    'dashboard.coachLeadersAllTime': 'Лидеры среди тренеров (за всё время)',
    'dashboard.whatIsThis': 'Что это?',
    'dashboard.coachLeadersExplanation':
      'Тренеры ранжируются по заполненным ParQ и успехам (потенциальные клиенты, отмеченные как заинтересованные).',
    'dashboard.notAvailable': 'Н/Д',
  },
  sv: {
    ...sharedDashboard,
    'nav.admin': 'Admin',
    'nav.fit3dAdmin': 'Fit3D-admin',
    'nav.market': 'Marknad',
    'nav.marketplace': 'Marknadsplats',
    'nav.survey': 'Enkät',
    'nav.clientScans': 'Kundskanningar',
    'nav.demoReport': 'Demorapport',
    'nav.demoComparison': 'Demojämförelse',
    'nav.manageCoaches': 'Hantera coacher',
    'nav.printable': 'Utskrivbar',
    'nav.myCoaches': 'Mina coacher',
    'nav.records': 'Poster',
    'nav.facilities': 'Anläggningar',
    'nav.scanners': 'Skannrar',
    'nav.coaches': 'Coacher',
    'nav.users': 'Användare',
    'nav.version': 'Version',
    'nav.client': 'Kund',
    'nav.report': 'Rapport',
    'nav.overlay': 'Överlagring',
    'nav.downloadMeasurements': 'Ladda ner mått',
    'cookie.notice': cookieNotice.sv,
    'dashboard.usageDashboard': 'Användningspanel',
    'dashboard.summary': 'Översikt',
    'dashboard.users': 'Användare',
    'dashboard.coaches': 'Coacher',
    'dashboard.scans': 'Skanningar',
    'dashboard.wins': 'Vinster',
    'dashboard.win': 'Vinst',
    'dashboard.winRate': 'Vinstgrad',
    'dashboard.coachActivity': 'Coachaktivitet',
    'dashboard.coachActivityMonthly': 'Coachaktivitet (månadsvis)',
    'dashboard.newUsers': 'Nya användare',
    'dashboard.newUsersMonthly': 'Nya användare (månadsvis)',
    'dashboard.activeUsers': 'Aktiva användare',
    'dashboard.activeUsersMonthly': 'Aktiva användare (månadsvis)',
    'dashboard.newScans': 'Nya skanningar',
    'dashboard.newScansMonthly': 'Nya skanningar (månadsvis)',
    'dashboard.maybe': 'Kanske',
    'dashboard.no': 'Nej',
    'dashboard.month': 'Månad',
    'dashboard.coachActivityLeaders': 'Ledare för coachaktivitet',
    'dashboard.coachLeadersCurrentMonth': 'Coachledare (innevarande månad)',
    'dashboard.coachLeadersAllTime': 'Coachledare (alla tider)',
    'dashboard.whatIsThis': 'Vad är det här?',
    'dashboard.coachLeadersExplanation':
      'Coacher rankas utifrån slutförda ParQ och vinster (potentiella kunder som markerats som intresserade).',
    'dashboard.notAvailable': 'Saknas',
  },
  ja: {
    ...sharedDashboard,
    'nav.admin': '管理',
    'nav.fit3dAdmin': 'Fit3D 管理',
    'nav.market': 'マーケット',
    'nav.marketplace': 'マーケットプレイス',
    'nav.survey': 'アンケート',
    'nav.clientScans': '顧客スキャン',
    'nav.demoReport': 'デモレポート',
    'nav.demoComparison': 'デモ比較',
    'nav.manageCoaches': 'コーチ管理',
    'nav.printable': '印刷用',
    'nav.myCoaches': 'マイコーチ',
    'nav.records': '記録',
    'nav.facilities': '施設',
    'nav.scanners': 'スキャナー',
    'nav.coaches': 'コーチ',
    'nav.users': 'ユーザー',
    'nav.version': 'バージョン',
    'nav.client': '顧客',
    'nav.report': 'レポート',
    'nav.overlay': 'オーバーレイ',
    'nav.downloadMeasurements': '計測値をダウンロード',
    'cookie.notice': cookieNotice.ja,
    'dashboard.usageDashboard': '利用状況ダッシュボード',
    'dashboard.summary': '概要',
    'dashboard.users': 'ユーザー',
    'dashboard.coaches': 'コーチ',
    'dashboard.scans': 'スキャン',
    'dashboard.wins': '成果',
    'dashboard.win': '成果',
    'dashboard.winRate': '成果率',
    'dashboard.coachActivity': 'コーチの活動',
    'dashboard.coachActivityMonthly': 'コーチの活動（月次）',
    'dashboard.newUsers': '新規ユーザー',
    'dashboard.newUsersMonthly': '新規ユーザー（月次）',
    'dashboard.activeUsers': 'アクティブユーザー',
    'dashboard.activeUsersMonthly': 'アクティブユーザー（月次）',
    'dashboard.newScans': '新規スキャン',
    'dashboard.newScansMonthly': '新規スキャン（月次）',
    'dashboard.maybe': 'たぶん',
    'dashboard.no': 'いいえ',
    'dashboard.month': '月',
    'dashboard.coachActivityLeaders': 'コーチ活動リーダー',
    'dashboard.coachLeadersCurrentMonth': 'コーチリーダー（今月）',
    'dashboard.coachLeadersAllTime': 'コーチリーダー（全期間）',
    'dashboard.whatIsThis': 'これは何ですか？',
    'dashboard.coachLeadersExplanation':
      'コーチは完了した ParQ と成果（関心ありとマークした見込み顧客）に基づいて順位付けされます。',
    'dashboard.notAvailable': 'なし',
  },
  tr: {
    ...sharedDashboard,
    'nav.admin': 'Yönetim',
    'nav.fit3dAdmin': 'Fit3D yönetimi',
    'nav.market': 'Pazar',
    'nav.marketplace': 'Pazar yeri',
    'nav.survey': 'Anket',
    'nav.clientScans': 'Müşteri taramaları',
    'nav.demoReport': 'Demo raporu',
    'nav.demoComparison': 'Demo karşılaştırması',
    'nav.manageCoaches': 'Koçları yönet',
    'nav.printable': 'Yazdırılabilir',
    'nav.myCoaches': 'Koçlarım',
    'nav.records': 'Kayıtlar',
    'nav.facilities': 'Tesisler',
    'nav.scanners': 'Tarayıcılar',
    'nav.coaches': 'Koçlar',
    'nav.users': 'Kullanıcılar',
    'nav.version': 'Sürüm',
    'nav.client': 'Müşteri',
    'nav.report': 'Rapor',
    'nav.overlay': 'Bindirme',
    'nav.downloadMeasurements': 'Ölçümleri indir',
    'cookie.notice': cookieNotice.tr,
    'dashboard.usageDashboard': 'Kullanım paneli',
    'dashboard.summary': 'Özet',
    'dashboard.users': 'Kullanıcılar',
    'dashboard.coaches': 'Koçlar',
    'dashboard.scans': 'Taramalar',
    'dashboard.wins': 'Kazanımlar',
    'dashboard.win': 'Kazanım',
    'dashboard.winRate': 'Kazanım oranı',
    'dashboard.coachActivity': 'Koç etkinliği',
    'dashboard.coachActivityMonthly': 'Koç etkinliği (aylık)',
    'dashboard.newUsers': 'Yeni kullanıcılar',
    'dashboard.newUsersMonthly': 'Yeni kullanıcılar (aylık)',
    'dashboard.activeUsers': 'Aktif kullanıcılar',
    'dashboard.activeUsersMonthly': 'Aktif kullanıcılar (aylık)',
    'dashboard.newScans': 'Yeni taramalar',
    'dashboard.newScansMonthly': 'Yeni taramalar (aylık)',
    'dashboard.maybe': 'Belki',
    'dashboard.no': 'Hayır',
    'dashboard.month': 'Ay',
    'dashboard.coachActivityLeaders': 'Koç etkinliği liderleri',
    'dashboard.coachLeadersCurrentMonth': 'Koç liderleri (bu ay)',
    'dashboard.coachLeadersAllTime': 'Koç liderleri (tüm zamanlar)',
    'dashboard.whatIsThis': 'Bu nedir?',
    'dashboard.coachLeadersExplanation':
      'Koçlar tamamlanan ParQ’lara ve kazanımlara (ilgili olarak işaretlenen potansiyel müşteriler) göre sıralanır.',
    'dashboard.notAvailable': 'Yok',
  },
  cs: {
    ...sharedDashboard,
    'nav.admin': 'Správa',
    'nav.fit3dAdmin': 'Správa Fit3D',
    'nav.market': 'Trh',
    'nav.marketplace': 'Tržiště',
    'nav.survey': 'Dotazník',
    'nav.clientScans': 'Skeny klientů',
    'nav.demoReport': 'Ukázkový report',
    'nav.demoComparison': 'Ukázkové porovnání',
    'nav.manageCoaches': 'Správa trenérů',
    'nav.printable': 'K tisku',
    'nav.myCoaches': 'Moji trenéři',
    'nav.records': 'Záznamy',
    'nav.facilities': 'Zařízení',
    'nav.scanners': 'Skenery',
    'nav.coaches': 'Trenéři',
    'nav.users': 'Uživatelé',
    'nav.version': 'Verze',
    'nav.client': 'Klient',
    'nav.report': 'Zpráva',
    'nav.overlay': 'Překrytí',
    'nav.downloadMeasurements': 'Stáhnout měření',
    'cookie.notice': cookieNotice.cs,
    'dashboard.usageDashboard': 'Přehled používání',
    'dashboard.summary': 'Souhrn',
    'dashboard.users': 'Uživatelé',
    'dashboard.coaches': 'Trenéři',
    'dashboard.scans': 'Skeny',
    'dashboard.wins': 'Úspěchy',
    'dashboard.win': 'Úspěch',
    'dashboard.winRate': 'Míra úspěchu',
    'dashboard.coachActivity': 'Aktivita trenérů',
    'dashboard.coachActivityMonthly': 'Aktivita trenérů (měsíčně)',
    'dashboard.newUsers': 'Noví uživatelé',
    'dashboard.newUsersMonthly': 'Noví uživatelé (měsíčně)',
    'dashboard.activeUsers': 'Aktivní uživatelé',
    'dashboard.activeUsersMonthly': 'Aktivní uživatelé (měsíčně)',
    'dashboard.newScans': 'Nové skeny',
    'dashboard.newScansMonthly': 'Nové skeny (měsíčně)',
    'dashboard.maybe': 'Možná',
    'dashboard.no': 'Ne',
    'dashboard.month': 'Měsíc',
    'dashboard.coachActivityLeaders': 'Lídři aktivity trenérů',
    'dashboard.coachLeadersCurrentMonth': 'Lídři trenérů (aktuální měsíc)',
    'dashboard.coachLeadersAllTime': 'Lídři trenérů (celkem)',
    'dashboard.whatIsThis': 'Co to je?',
    'dashboard.coachLeadersExplanation':
      'Trenéři jsou řazeni podle dokončených ParQ a úspěchů (potenciální klienti označení jako zájemci).',
    'dashboard.notAvailable': 'Není k dispozici',
  },
  el: {
    ...sharedDashboard,
    'nav.admin': 'Διαχείριση',
    'nav.fit3dAdmin': 'Διαχείριση Fit3D',
    'nav.market': 'Αγορά',
    'nav.marketplace': 'Αγορά',
    'nav.survey': 'Έρευνα',
    'nav.clientScans': 'Σαρώσεις πελατών',
    'nav.demoReport': 'Δοκιμαστική αναφορά',
    'nav.demoComparison': 'Δοκιμαστική σύγκριση',
    'nav.manageCoaches': 'Διαχείριση προπονητών',
    'nav.printable': 'Εκτυπώσιμο',
    'nav.myCoaches': 'Οι προπονητές μου',
    'nav.records': 'Αρχεία',
    'nav.facilities': 'Εγκαταστάσεις',
    'nav.scanners': 'Σαρωτές',
    'nav.coaches': 'Προπονητές',
    'nav.users': 'Χρήστες',
    'nav.version': 'Έκδοση',
    'nav.client': 'Πελάτης',
    'nav.report': 'Αναφορά',
    'nav.overlay': 'Επικάλυψη',
    'nav.downloadMeasurements': 'Λήψη μετρήσεων',
    'cookie.notice': cookieNotice.el,
    'dashboard.usageDashboard': 'Πίνακας χρήσης',
    'dashboard.summary': 'Σύνοψη',
    'dashboard.users': 'Χρήστες',
    'dashboard.coaches': 'Προπονητές',
    'dashboard.scans': 'Σαρώσεις',
    'dashboard.wins': 'Επιτυχίες',
    'dashboard.win': 'Επιτυχία',
    'dashboard.winRate': 'Ποσοστό επιτυχίας',
    'dashboard.coachActivity': 'Δραστηριότητα προπονητών',
    'dashboard.coachActivityMonthly': 'Δραστηριότητα προπονητών (μηνιαία)',
    'dashboard.newUsers': 'Νέοι χρήστες',
    'dashboard.newUsersMonthly': 'Νέοι χρήστες (μηνιαία)',
    'dashboard.activeUsers': 'Ενεργοί χρήστες',
    'dashboard.activeUsersMonthly': 'Ενεργοί χρήστες (μηνιαία)',
    'dashboard.newScans': 'Νέες σαρώσεις',
    'dashboard.newScansMonthly': 'Νέες σαρώσεις (μηνιαία)',
    'dashboard.maybe': 'Ίσως',
    'dashboard.no': 'Όχι',
    'dashboard.month': 'Μήνας',
    'dashboard.coachActivityLeaders': 'Κορυφαίοι σε δραστηριότητα προπονητών',
    'dashboard.coachLeadersCurrentMonth': 'Κορυφαίοι προπονητές (τρέχων μήνας)',
    'dashboard.coachLeadersAllTime': 'Κορυφαίοι προπονητές (συνολικά)',
    'dashboard.whatIsThis': 'Τι είναι αυτό;',
    'dashboard.coachLeadersExplanation':
      'Οι προπονητές κατατάσσονται με βάση τα ολοκληρωμένα ParQ και τις επιτυχίες (δυνητικοί πελάτες που σημείωσαν ως ενδιαφερόμενους).',
    'dashboard.notAvailable': 'Μ/Δ',
  },
  hr: {
    ...sharedDashboard,
    'nav.admin': 'Admin',
    'nav.fit3dAdmin': 'Fit3D admin',
    'nav.market': 'Tržište',
    'nav.marketplace': 'Tržnica',
    'nav.survey': 'Anketa',
    'nav.clientScans': 'Skenovi klijenata',
    'nav.demoReport': 'Demo izvještaj',
    'nav.demoComparison': 'Demo usporedba',
    'nav.manageCoaches': 'Upravljanje trenerima',
    'nav.printable': 'Za ispis',
    'nav.myCoaches': 'Moji treneri',
    'nav.records': 'Zapisi',
    'nav.facilities': 'Objekti',
    'nav.scanners': 'Skeneri',
    'nav.coaches': 'Treneri',
    'nav.users': 'Korisnici',
    'nav.version': 'Verzija',
    'nav.client': 'Klijent',
    'nav.report': 'Izvještaj',
    'nav.overlay': 'Preklapanje',
    'nav.downloadMeasurements': 'Preuzmi mjere',
    'cookie.notice': cookieNotice.hr,
    'dashboard.usageDashboard': 'Nadzorna ploča korištenja',
    'dashboard.summary': 'Sažetak',
    'dashboard.users': 'Korisnici',
    'dashboard.coaches': 'Treneri',
    'dashboard.scans': 'Skeniranja',
    'dashboard.wins': 'Pobjede',
    'dashboard.win': 'Pobjeda',
    'dashboard.winRate': 'Stopa pobjeda',
    'dashboard.coachActivity': 'Aktivnost trenera',
    'dashboard.coachActivityMonthly': 'Aktivnost trenera (mjesečno)',
    'dashboard.newUsers': 'Novi korisnici',
    'dashboard.newUsersMonthly': 'Novi korisnici (mjesečno)',
    'dashboard.activeUsers': 'Aktivni korisnici',
    'dashboard.activeUsersMonthly': 'Aktivni korisnici (mjesečno)',
    'dashboard.newScans': 'Nova skeniranja',
    'dashboard.newScansMonthly': 'Nova skeniranja (mjesečno)',
    'dashboard.maybe': 'Možda',
    'dashboard.no': 'Ne',
    'dashboard.month': 'Mjesec',
    'dashboard.coachActivityLeaders': 'Lideri aktivnosti trenera',
    'dashboard.coachLeadersCurrentMonth': 'Lideri trenera (tekući mjesec)',
    'dashboard.coachLeadersAllTime': 'Lideri trenera (sveukupno)',
    'dashboard.whatIsThis': 'Što je ovo?',
    'dashboard.coachLeadersExplanation':
      'Treneri se rangiraju prema dovršenim ParQ-ovima i pobjedama (potencijalni klijenti označeni kao zainteresirani).',
    'dashboard.notAvailable': 'N/D',
  },
}
